// 404 Page Constants
import i18n from "i18next";

export interface NotFoundVariant {
  id: number;
  image: string;
  readonly message: string;
  readonly altText: string;
}

export const getNotFoundTitle = () => i18n.t("landing:notFound.title");
export const getNotFoundSubtitle = () => i18n.t("landing:notFound.subtitle");

const makeVariant = (id: 1 | 2 | 3): NotFoundVariant => ({
  id,
  image: `/assets/404/404_${id}.webp`,
  get message() {
    return i18n.t(`landing:notFound.variants.v${id}.message`);
  },
  get altText() {
    return i18n.t(`landing:notFound.variants.v${id}.altText`);
  },
});

export const NOT_FOUND_VARIANTS: NotFoundVariant[] = [
  makeVariant(1),
  makeVariant(2),
  makeVariant(3),
];
